import React, { useState } from "react";
import { ReactComponent as GoogleLogo } from "../../../assets/icons/googleLogo.svg";
import { ReactComponent as EmailLogo } from "../../../assets/icons/emailLogo.svg";
import { Button, message } from "antd";
import { useTranslation } from "react-i18next";
import Utils from "../../../utils/utils";
import axios from "axios";
import { api_config } from "../../../constants/api";
import sentGAEvent from "@/ga";
import { useSelector } from "react-redux";
export default function InitState(props) {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation(["userLoginTips", "purchase"]);
  const { t: t2 } = useTranslation(["purchase"]);
   const pidType = {
     en: 4011, //en 1
     br: 4068, //pt 葡萄牙语 1
    fr: 4072, //fr 1
    it: 4070, //it 1
    ru: 4071, //ru 1
     ar: 4069, //ar 1
     es: 4073, //es 1
    // tr: 4080, //tr
    kr: 4067, //ko 1
    jp: 4076, //ja 1
    nl: 4074, //nl 1
     de: 4075, //de 1
    tw: 4077, //tw 1
    inn: 4078, //hi 1
    id: 4079 //id 1

    // ar, cn, en, id, inn, kr, br, jp, tw, it, fr, ru, es, de, nl
   }
  const videoTimes =
    useSelector((state) => state.userinfo.signUpModal?.counts) || 0;
  const GoogleLogin = () => {
    sentGAEvent({
      category: "Subscribe",
      action: "SubscribePrompt_GoogleLogin_Click",
    });
    setLoading(true);

    axios({
      method: "POST",
      url: api_config.googleUrl,
      data: {
        pid: pidType[`${Utils.getLanguage()}`] || 4011,
        redirect_uri: window.location.href,
        token: "$2y$10$NCD4zFjrZzJvKN7YSyXIQOb/ivtITqcFKh6c08ZZ80XSGdHXdZdt.",
      },
    })
      .then((obj) => {
        let res = obj.data;
        if (res.code === 200) {
          setLoading(false);
          window.location.href = res.data.redirect;
        }
      })
      .catch((err) => {
        setLoading(false);
        message.error(t("500"));
      });
  };

  const EmailLogin = () => {
    sentGAEvent({
      category: "Subscribe",
      action: "SubscribePrompt_EmailLogin_Click",
    });
    props.changeStep(2);
  };

  const linkToService = () => {
    window.open(Utils.getHitPawServiceLink());
  };

  const linkToPrivacy = () => {
    window.open(Utils.getHitPawPrivacy());
  };

  return (
    <div className="initState">
      <div className="header">
        <div className="loginTitle">
          {videoTimes >= 6
            ? t2("freeTimesLimitTitle")
            : t2("fileSizeLimitTitle")}
        </div>
      </div>
      <div className="loginBtn">
        <Button
          onClick={GoogleLogin}
          className="googleBtn"
          type="default"
          loading={loading}
          block
        >
          <GoogleLogo className="googleIcon" />
          <div className="btnContent">{t("ContinuewithGoogle")}</div>
        </Button>
        <Button
          disabled={loading}
          onClick={EmailLogin}
          className="emailBtn"
          type="default"
          block
        >
          <EmailLogo className="emailIcon" />
          <div className="btnContent">{t("ContinuewithEmail")}</div>
        </Button>
      </div>
      <div className="serviceAndPolicy">
        <div className="serviceContainer">
          {t("Byproceedingyouagreetoour")}
          <span onClick={() => linkToService()} className="serviceLink">
            {t("ServicesofUse")}
          </span>
          {t("and")}
          <span onClick={() => linkToPrivacy()} className="serviceLink">
            {t("PrivacyPolicy")}
          </span>
        </div>
      </div>
    </div>
  );
}
